export enum SampleIntervalUnit {
    Milisecond = 0,
    Microsecond = 1,
}